import { useState } from 'react'

import { Icon } from '@mxenabled/mx-icons'

import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

export interface MenuItemProps {
  key: string
  icon: React.ReactNode
  text: string
}

interface MenuActionProps {
  ariaHidden?: boolean
  ariaLabel: string
  menuItems: MenuItemProps[]
  onItemClick: (index: number, key: string) => void
  onOpen: () => void
  tabIndex?: number
}

export const MenuAction = ({
  ariaHidden = false,
  ariaLabel,
  menuItems = [],
  onItemClick,
  onOpen,
  tabIndex = 0,
  ...restProps
}: MenuActionProps) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const onClose = () => setAnchorEl(null)

  const handleMenuItem = (i: number, key: string) => {
    onClose()
    onItemClick(i, key)
  }

  const handleOpen: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    setAnchorEl(e.currentTarget)
    onOpen()
  }

  return (
    <>
      <IconButton
        aria-hidden={ariaHidden}
        aria-label={ariaLabel}
        onClick={handleOpen}
        sx={{ position: 'relative !important', bottom: 6 }}
        tabIndex={tabIndex}
        {...restProps}
      >
        <Icon
          name="more_horiz"
          size={24}
          sx={{
            color: 'text.primary',
            fontVariationSettings: 'initial',
          }}
        />
      </IconButton>
      <Menu
        MenuListProps={{ sx: { width: 212 } }}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        disableScrollLock={true}
        onClose={onClose}
        open={Boolean(anchorEl)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        {menuItems.map(({ icon, key, text }, i) => (
          <MenuItem key={key} onClick={() => handleMenuItem(i, key)} sx={{ p: 12 }}>
            <ListItemIcon sx={{ minWidth: '32px !important' }}>{icon}</ListItemIcon>
            <ListItemText
              primary={text}
              slotProps={{
                primary: {
                  fontWeight: 'normal',
                  fontSize: 15,
                  lineHeight: '20px',
                },
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
